/**
 * v0 by Vercel.
 * @see https://v0.dev/t/A9mUhuTcKze
 * Documentation: https://v0.dev/docs#integrating-generated-code-into-your-nextjs-app
 */
"use client"
import Link from "next/link"
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { login, signup } from "@/app/(authapp)/login/actions"
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import Image from 'next/image'

export default function Component() {
  const [message, setMessage] = useState("")
  const router = useRouter()
  const handleLogin = async (formData: FormData) => {
    const response = await login(formData)
    if (response.error) {
      setMessage(response.error)
    } else if (response.success) {
      router.push('/dashboard')
    }
  }

  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-black px-4 py-12 sm:px-6 lg:px-8">
      
      <div className="mx-auto w-full max-w-md space-y-8">
        <div>
          <Image src="/holistika-short-100x100.svg" alt="Logo" width={100} height={100} className="mx-auto h-24 w-auto" />
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-muted-background">
            Sign in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-muted-background">
            Welcome back, Researcher
          </p>
        </div>
        <Tabs defaultValue="login" className="space-y-4">
          <TabsList className="flex justify-center">
            <TabsTrigger value="login">Login</TabsTrigger>
            <TabsTrigger value="signup">Sign Up</TabsTrigger>
          </TabsList>
          <TabsContent value="login">
            <form action={handleLogin} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-background">
                  Email address
                </Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  placeholder="name@example.com"
                  className="bg-background text-foreground"
                />
              </div>
              <div>
                <div className="flex items-center justify-between">
                  <Label htmlFor="password" className="text-background">
                    Password
                  </Label>
                  <Link
                    href="#"
                    className="text-sm text-primary-foreground hover:text-primary-foreground/90"
                    prefetch={false}
                  >
                    Forgot password?
                  </Link>
                </div>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  placeholder="Enter your password"
                  className="bg-background text-foreground"
                />
              </div>
              <Button type="submit" className="w-full bg-primary text-primary-foreground">
                Sign in
              </Button>
            </form>
          </TabsContent>
          <TabsContent value="signup">
            <form action={signup} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-background">
                  Email address
                </Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  placeholder="name@example.com"
                  className="bg-background text-foreground"
                />
              </div>
              <div>
                <Label htmlFor="password" className="text-background">
                  Password
                </Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                  required
                  placeholder="Enter your password"
                  className="bg-background text-foreground"
                />
              </div>
              <div>
                <Label htmlFor="confirm-password" className="text-background">
                  Confirm Password
                </Label>
                <Input
                  id="confirm-password"
                  name="confirm-password"
                  type="password"
                  autoComplete="new-password"
                  required
                  placeholder="Confirm your password"
                  className="bg-background text-foreground"
                />
              </div>
              <Button type="submit" className="w-full bg-primary text-primary-foreground">
                Sign up
              </Button>
            </form>
          </TabsContent>
        </Tabs>
        {message && (
          <p className="mt-4 text-center text-sm text-red-500">
            {message}
          </p>
        )}
      </div>
    </div>
  )
}